import { render, staticRenderFns } from "./SGColors.vue?vue&type=template&id=898a580c&scoped=true&"
import script from "./SGColors.vue?vue&type=script&lang=js&"
export * from "./SGColors.vue?vue&type=script&lang=js&"
import style0 from "./SGColors.vue?vue&type=style&index=0&id=898a580c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898a580c",
  null
  
)

export default component.exports